import "./App.css";
import { Box, CssBaseline } from "@mui/material";
import { NavBar } from "./Components/NavBar/NavBar";
import { NAV_BAR_HEIGHT } from "./Components/NavBar/navBarMetrics";
import { GraphService } from "./Services/GraphService";
import { LicenseInfo } from "@mui/x-license";
import { MFTEnvironmentVariables } from "./MFTEnvironmentVariables";
import { useEffect } from "react";
import { MainSplit } from "./Components/Architecturals/MainSplit";
import { MessageProvider } from "./Services/Nats";
import { ListedAlgoProvider } from "./features/lazertrader/contexts/listAlgosContext";
import { PrefillProvider } from "./Services/PrefillContextProvider";
import { NotificationProvider } from "./features/lazertrader/contexts/notifications";
import { ThemeProviderWrapper } from "./theme";
import { ErrorBoundary } from "react-error-boundary";
import { ErrorPage } from "./Components/errorPage";

LicenseInfo.setLicenseKey(
  "d9c27d2bd2c007b21643c7e4f3ceaef7Tz0xMjM4MzIsRT0xNzk5Mjc5OTk5MDAwLFM9cHJlbWl1bSxMTT1zdWJzY3JpcHRpb24sUFY9aW5pdGlhbCxLVj0y"
);

const App = () => {
  useEffect(() => {
    document.title = MFTEnvironmentVariables.isProduction
      ? "JEPX Lazer Desk PROD"
      : "JEPX Lazer Desk TEST";
  }, []);

  return (
    <ThemeProviderWrapper>
      <Box sx={{ position: "absolute", top: 0, left: 0, right: 0, bottom: 0 }}>
        <CssBaseline enableColorScheme={true} />

        <NotificationProvider>
          <GraphService>
            <ListedAlgoProvider>
              <PrefillProvider>
                <MessageProvider>
                  <NavBar />
                  <ErrorBoundary FallbackComponent={ErrorPage}>
                    <Box
                      display={"flex"}
                      flexGrow={1}
                      gap={1}
                      p={1}
                      paddingTop={0}
                      sx={{
                        height: `calc(100vh - ${NAV_BAR_HEIGHT}px) !important`,
                        bgcolor: "chrome.canvas",
                      }}
                      width={"100vw"}
                    >
                      {/* Order book and the algo form share the top row; the
                          algo grids take the full width beneath them. */}
                      <Box sx={{ flex: 1, minWidth: 0 }}>
                        <MainSplit />
                      </Box>
                    </Box>
                  </ErrorBoundary>
                </MessageProvider>
              </PrefillProvider>
            </ListedAlgoProvider>
          </GraphService>
        </NotificationProvider>
      </Box>
    </ThemeProviderWrapper>
  );
};

export { App };
